<template>
  <div class="logo-div">
    <!-- <img src="/assets/images/Logos/topotradeLogo1.webp" class="logo-image" /> -->
    <img :src="$store.getters.images.logo" alt="" class="logo-image">
  </div>
  <!-- <div class="title">Register</div> -->
  <div class="subtitle">{{$translation($websiteText().sign_up_login_popup_signup_welcome_onboard)}}</div>

  <button
    @click="() => loginWithGoogle()"
    class="nobutton"
    style="display: flex; margin: 0 auto"
  >
    <div class="rectangle">
      <img src="/assets/images/GoogleLogo.png" />
      <div class="google">{{$translation($websiteText().sign_up_login_popup_continue_with_google)}}</div>
    </div>
  </button>
  <hr class="mt-3 mb-3" />

  <div v-if="responseRegisterError.message" class="mt-3 error-message">
    <t-inline-message
      :message="responseRegisterError.message"
      severity="error"
    />
  </div>

  <div v-if="$store.getters.verifyMessage" class="mt-3 error-message">
    <t-inline-message
      :message="$store.getters.verifyMessage"
    />
  </div>

  

  <div class="form">
    <t-form :onSubmit="register" :schema="schema" v-if="!$store.getters.verifyMessage">
      <div class="row">
        <div class="col-md-6">
          <t-input-text
            v-model="registrationData.firstName"
            name="firstName"
            :placeholder="$translation($websiteText().my_profile_first_name)"
            :onInputText="onInput"
            :style="'height: 42px'"
          />
        </div>
        <div class="col-md-6">
          <t-input-text
            v-model="registrationData.lastName"
            name="lastName"
            :placeholder="$translation($websiteText().my_profile_last_name)"
            :onInputText="onInput"
            :style="'height: 42px'"
          />
        </div>
      </div>
      <t-input-text
        v-model="registrationData.email"
        name="email"
        :placeholder="$translation($websiteText().my_profile_email)"
        :onInputText="onInput"
        :style="'height: 42px'"
      />
      <t-input-text
        type="password"
        v-model="registrationData.password"
        name="password"
        :placeholder="$translation($websiteText().website_generals_password)"
        :onInputText="onInput"
        :style="'height: 42px'"
      />
      <t-input-text
        type="password"
        name="confirmPassword"
        v-model="registrationData.confirmPassword"
        :placeholder="$translation($websiteText().website_generals_confirm_password)"
        :onInputText="onInput"
        :style="'height: 42px'"
      />
      <div class="d-flex flex-row align-items-center mb-2">
        <t-checkbox v-model="registrationData.agree" name="agree" style="margin-top:15px;"/>
        &nbsp; &nbsp;
        <div class="agree" @click="goToTerms()">{{$translation($websiteText().sign_up_login_popup_agree_to_terms)}}</div>
      </div>

      <div class="submit-btn-container">
        <t-button
          type="submit"
          :label="$translation($websiteText().sign_up_login_popup_signup_submit_button)"
          color="primary-color"
          :onClick="registerValidate"
          buttonClass="signin-btn-class"
        />
      </div>
    </t-form>
  </div>
  <hr class="mt-3 mb-3" />

  <div style="display: flex; flex-direction: row; text-align:center">
    <!-- <div class="account">{{$translation($websiteText().sign_up_login_popup_already_have_an_account)}}</div> -->
    
    <button
      class="nobutton"
      style="padding: 0px; margin-bottom: 5%"
      @click="() => goToLogin()"
    >

      <div class="signup-btn">{{$translation($websiteText().sign_up_login_popup_login_here_button)}}</div>
    </button>
  </div>
</template>
<script>
import { reactive } from "@vue/reactivity";
import TButton from "../../../common/components/buttons/TButton.vue";
import TInputText from "../../../common/components/input-text/TInputText.vue";
import TForm from "../../../common/components/TForm.vue";
import TCheckbox from "../../../common/components/controls/TCheckbox.vue";
import TInlineMessage from "../../../common/components/messages/TInlineMessage.vue";
import { useStore } from "vuex";
import * as Yup from "yup";

import store from "../../../store";
import {
  REGISTER_REQUEST,
  REPLACE_AUTH_ACTIVE_COMPONENT,
} from "../store/actions";
import { SHOW_TOAST_MESSAGE } from "../../../common/store/actions";
import GeneralHelper from "../../../common/helpers/GeneralHelper";
import Signin from "./Signin.vue";
export default {
  name:"Register",
  components: {
    TButton,
    TInputText,
    TForm,
    TCheckbox,
    TInlineMessage,
  },

  setup() {
    const store = useStore()
    let responseRegisterError = reactive({
      message: "",
    });

    const registrationData = reactive({
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      confirmPassword: "",
      agree: false,
    });

    const onInput = () => {
      responseRegisterError.message = "";
    };

    const schema = Yup.object().shape({
      firstName: Yup.string().required().label("First name"),
      lastName: Yup.string().required().label("Last name"),
      email: Yup.string().required().email().label("Email"),
      password: Yup.string().required().min(6).label("Password"),
      confirmPassword: Yup.string().oneOf(
        [Yup.ref("password"), null],
        "Passwords must match"
      ),
      agree: Yup.boolean().oneOf([true], "Please agree"),
    });

    const goToLogin = () => {
      store.dispatch(REPLACE_AUTH_ACTIVE_COMPONENT, Signin);
    };

    const registerValidate = () => {
      schema
        .validate(registrationData, { abortEarly: false })
        .then()
        .catch((e) => {
          for (let i = 0; i < e.errors.length; i++) {
            store.dispatch(
              SHOW_TOAST_MESSAGE,
              GeneralHelper.buildMessage(3, e.errors[i])
            );
          }
        });
    };
    const register = () => {
      store
        .dispatch(REGISTER_REQUEST, registrationData)
        .then(() => {})
        .catch((e) => {
          if (e.response && e.response.data) {
            store.dispatch(
              SHOW_TOAST_MESSAGE,
              GeneralHelper.buildMessage(3, e.response.data.message)
            );
          }
        });
    };

    return {
      schema,
      register,
      registrationData,
      responseRegisterError,
      onInput,
      store,
      registerValidate,
      goToLogin,
    };
  },

  unmounted(){
    this.$store.commit('setVerifyMessage', verifyMessage)
  },
  methods:{
    goToTerms(){
      let route = this.$router.resolve({ 
                  name: 'terms',
                  })
      window.open(route.href, '_blank')
    },
  }
};
</script>
<style lang="scss" scoped>

  @import '../style/auth.scss';

  .account {
    @include f-button1;
    color: $light-black;
    font-weight: 600;
    vertical-align: middle;
    margin-right: 2px;
  }
  .signup-btn {
    @include f-button1;
    color: $brand-color;
    font-weight: bold;
    text-decoration: underline;
  }

  
  .agree {
    color: $light-black;
    margin-bottom: 12px;
    @include f-button1;
    cursor: pointer;
    text-align: flex-start;
    :hover{
      text-decoration: underline !important;
      color: $tertiary-color !important;
    }
  
  }
</style>
